// Swiper styles
import "swiper/swiper.scss"
import "swiper/modules/pagination.scss"
import "swiper/modules/effect-creative.scss"
import "swiper/modules/effect-fade.scss"

// Types
import type {Swiper} from "swiper/types"
import SwiperClass from "swiper"
import {Keyboard, Pagination, Navigation, EffectCreative, EffectFade, Autoplay, Manipulation} from "swiper/modules"

// Export Swiper to window object for global access
window.Swiper = {
  default: SwiperClass,
  Keyboard,
  Pagination,
  Navigation,
  EffectCreative,
  EffectFade,
  Autoplay,
  Manipulation,
}

// Sliders

import "@components/groups/hero-slider-group/hero-slider-group"
import "@components/groups/food-menu-group/food-menu-group"
import "@components/groups/testimonials-group/testimonials-group--slider"
import "@components/groups/review-group/review-group--slider"

/**
 * If you need do something with the swiper instance, you can use the following interface
 * @example import {SwiperElement} from "js/swiper/swiper"
 *
 * const swiperElement = document.querySelector<SwiperElement>(".your-swiper")
 *
 * swiperElement.swiper
 */
export interface SwiperElement extends HTMLElement {
  swiper?: Swiper
}

// Declare global types
declare global {
  interface Window {
    Swiper: {
      default: typeof SwiperClass
      Keyboard: typeof Keyboard
      Pagination: typeof Pagination
      Navigation: typeof Navigation
      EffectCreative: typeof EffectCreative
      EffectFade: typeof EffectFade
      Autoplay: typeof Autoplay
      Manipulation: typeof Manipulation
    }
  }
}
